import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const es = {
  // Top bar / nav
  brand: { tagline: "Inteligencia universitaria" },
  nav: {
    dashboard: "Dashboard",
    convenios: "Convenios",
    convenios_mis: "Mis convenios",
    cargar_convenio: "Cargar convenio",
    acciones: "Acciones",
    registrar_accion: "Registrar acción",
    facultades: "Facultades",
    unidades: "Unidades",
    estructuras: "Estructuras",
    usuarios: "Usuarios",
    configuracion: "Configuración",
    mi_facultad: "Mi facultad",
    mi_unidad: "Mi unidad",
    cerrar_sesion: "Cerrar sesión",
    volver_inicio: "Volver al inicio",
    ingresar: "Ingresar",
    probar_demo: "Probar demo",
    acceso_clientes: "Acceso clientes",
  },
  // Hero
  landing: {
    intel_tagline: "Inteligencia para la vinculación universitaria",
    hero_q1: "Sabe qué estás haciendo",
    hero_q2: "con tus convenios.",
    hero_desc:
      "vincularedu te muestra qué pasa realmente con cada convenio institucional: vigencia, acciones, impacto. Para tomar mejores decisiones y mantener",
    hero_desc_em: "consistencia de información oportuna",
    hero_desc_after:
      "en procesos de acreditación a nivel de unidades académicas y programas.",
    cta_demo: "Probar la demo",
    cta_login: "Acceso clientes",
    demo_disclaimer: "Demo sin registro · Datos de ejemplo · Reinicia automáticamente",
    discover: "Lo que descubren las universidades",
    convenios_firmados: "Convenios firmados",
    activos_verdad: "Activos de verdad",
    por_vencer_90d: "Por vencer (90d)",
    sin_actividad: "Sin actividad",
    quote:
      "«La mitad no había generado movimiento en años» — relato típico de un director de relaciones internacionales.",
    section_producto: "Producto",
    section_producto_kicker: "01 Producto",
    section_producto_h: "Todo lo que necesitas para gestionar la",
    section_producto_em: "vinculación real",
    feat_ocr_t: "OCR con IA",
    feat_ocr_d: "Sube el PDF del convenio. GPT-5.2 extrae institución, fechas, áreas temáticas y tipo. Solo revisas y confirmas.",
    feat_acc_t: "Acciones bajo cada convenio",
    feat_acc_d: "Registra intercambios, pasantías, publicaciones y eventos. Individual o por carga masiva con plantilla Excel inteligente.",
    feat_dash_t: "Dashboard ejecutivo",
    feat_dash_d: "Semáforo de vigencia, tasa de activación, mapa territorial, convenios zombies y alertas de vencimiento.",
    feat_vig_t: "Vigencia flexible",
    feat_vig_d: "Fecha fija, indefinida o auto-renovable. Inicia procesos de no-renovación con aviso previo configurable.",
    feat_roles_t: "Roles bien definidos",
    feat_roles_d: "Oficina de Vinculación, Facultades, Unidades y Directivos. Cada uno ve y edita lo que le corresponde.",
    feat_conf_t: "Acreditación lista",
    feat_conf_d: "Trazabilidad por unidad académica y programa. Reportes consistentes y datos auditables para acreditación.",
    section_flujo: "Cómo funciona",
    section_flujo_kicker: "02 Cómo funciona",
    section_flujo_h: "De un PDF olvidado a",
    section_flujo_em: "datos accionables",
    flujo_1_t: "Carga el convenio",
    flujo_1_d: "PDF firmado, plantilla o registro manual. La IA hace el trabajo pesado.",
    flujo_2_t: "Asigna estructura",
    flujo_2_d: "Vincula al convenio con facultades, unidades académicas o vicerrectorías responsables.",
    flujo_3_t: "Registra acciones",
    flujo_3_d: "Cada intercambio, evento o publicación bajo ese convenio queda trazado.",
    flujo_4_t: "Visualiza impacto",
    flujo_4_d: "Tasa de activación, ranking por unidad, países cubiertos. La realidad, no los papeles.",
    section_for: "Para quién",
    section_for_kicker: "03 Para quién",
    section_for_h: "Diseñado para",
    section_for_em: "universidades",
    section_for_h2: "que quieren tomar mejores decisiones.",
    section_for_desc:
      "Si tu institución tiene más de 50 convenios y no sabes cuántos están vivos, vincularedu es para ti. Implementación en días, no meses.",
    p1_rol: "Oficinas de Vinculación / RR.II.",
    p1_v: "Catálogo único, IA para extraer datos de PDFs y dashboard global.",
    p2_rol: "Decanos y facultades",
    p2_v: "Registra acciones del semestre y visualiza tu propio desempeño.",
    p3_rol: "Vicerrectorías y dirección de acreditación",
    p3_v: "Datos consistentes y trazables para procesos de acreditación y reportes ejecutivos.",
    final_cta_kicker: "Empieza ahora",
    final_cta_h1: "¿Quieres",
    final_cta_em: "decisiones",
    final_cta_h2: "mejores y datos consistentes",
    final_cta_h3: "para acreditar?",
    final_cta_desc:
      "Prueba la demo sin registro o solicita acceso para tu universidad. Sin instalación, sin compromiso.",
    footer_tag: "Inteligencia universitaria",
  },
  // Login
  login: {
    kicker: "Acceso clientes",
    title: "Ingresar.",
    no_account: "Para universidades con cuenta activa. ¿Sin cuenta?",
    try_demo: "Prueba la demo",
    email: "Email",
    password: "Contraseña",
    submit: "Ingresar",
    loading: "Ingresando...",
    contact_text: "¿Tu universidad aún no tiene cuenta?",
  },
  // Demo
  demo: {
    kicker: "Modo demo · Datos compartidos",
    h1_a: "Entra como",
    h1_em: "quieras",
    desc:
      "Explora vincularedu con datos de ejemplo. Cada perfil muestra una experiencia distinta. No necesitas registrarte — los datos son compartidos entre visitantes y se reinician periódicamente.",
    enter_as: "Entrar como",
    enter: "Entrar",
    entering: "Entrando...",
    warn_title: "Importante",
    warn_text:
      "Este es un entorno de demostración con datos compartidos entre todos los visitantes. Cualquier cosa que crees, modifiques o elimines será visible para los demás. Para un entorno privado de tu universidad,",
    warn_link: "accede como cliente",
    warn_or: "o",
    warn_contact: "contáctanos",
    roles: {
      admin_label: "Oficina de Vinculación (Admin)",
      admin_desc: "Crea convenios, gestiona facultades, ve dashboard global.",
      facultad_label: "Facultad de Ingeniería",
      facultad_desc: "Registra acciones bajo sus convenios.",
      unidad_label: "Unidad Académica (Informática)",
      unidad_desc: "Sub-nivel bajo facultad.",
      directivo_label: "Directivo (Rectoría)",
      directivo_desc: "Vista ejecutiva de solo lectura.",
    },
  },
  // Dashboard
  dashboard: {
    kicker: "Dashboard",
    metrica_estrella: "Métrica estrella",
    tasa_a: "Tasa de",
    tasa_em: "activación",
    tasa_desc: "Convenios activos con al menos una acción registrada en los últimos 12 meses.",
    de: "de",
    activos_label: "activos",
    actividad: "Actividad",
    acciones_12m: "acciones últimos 12 meses",
    cobertura: "Cobertura",
    paises_distintos: "países distintos",
    distribucion: "Distribución",
    mapa_territorial: "Mapa territorial",
    ranking: "Ranking",
    facultades_por: "Facultades por",
    actividad_em: "actividad",
    sin_actividad: "Sin actividad",
    convenios_zombies: "zombies",
    alertas: "Alertas",
    proximos: "Próximos a",
    vencer: "vencer",
    title_suffix: "Inteligencia universitaria",
  },
  // Common
  common: {
    loading: "Cargando...",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    new: "Nuevo",
    search: "Buscar",
    filters: "Filtros",
    total: "Total",
    pais: "País",
    tipo: "Tipo",
    estado: "Estado",
    vigencia: "Vigencia",
    todos: "Todos",
    activos: "Activos",
    por_vencer: "Por vencer",
    vencidos: "Vencidos",
    language: "Idioma",
    welcome: "Bienvenido",
    session_started: "Sesión iniciada",
    back: "Volver",
    yes: "Sí",
    no: "No",
    optional: "opcional",
    administration: "Administración",
  },
  // Convenios
  convenios: {
    page_title: "Convenios",
    kicker: "Registro institucional",
    kicker_mis: "Mis convenios",
    btn_new: "Cargar convenio",
    search_placeholder: "Buscar por institución, país, ciudad, áreas, observaciones…",
    searching_tokens: "Buscando {{n}} términos:",
    col_institucion: "Institución",
    col_pais: "País",
    col_tipo: "Tipo",
    col_facultad: "Facultad",
    col_vencimiento: "Vencimiento",
    col_estado: "Estado",
    empty: "Sin convenios",
    no_match: "Ningún convenio coincide con los filtros",
    of_label: "de",
    results_one: "convenio",
    results_other: "convenios",
    clear_all: "Limpiar todo",
    clear_filters: "Limpiar filtros",
    filters_active: "{{n}} filtro(s) activo(s)",
    indefinido: "Indefinido",
    vig_fija: "Fecha fija",
    vig_auto: "Auto-renovable",
    tipo_marco: "Marco",
    tipo_esp: "Específico",
  },
  // Convenio detail
  convenio_detail: {
    btn_register_action: "Registrar acción",
    section_vigencia: "Vigencia",
    section_partes: "Partes",
    section_actividad: "Actividad",
    fecha_firma: "Fecha de firma",
    fecha_vencimiento: "Vencimiento",
    aviso_previo: "Aviso previo",
    days: "días",
    no_renovacion: "No renovación iniciada",
    motivo: "Motivo",
    btn_iniciar_no_renov: "Iniciar no renovación",
    btn_cancelar_no_renov: "Cancelar no renovación",
    historial: "Historial de acciones",
    sin_acciones: "Sin acciones registradas",
    participantes: "participantes",
  },
  // Acciones
  acciones: {
    page_title: "Acciones",
    kicker: "Registro",
    btn_new: "Nueva acción",
    btn_bulk: "Carga Excel",
    kpi_total: "Total",
    kpi_participantes: "Participantes",
    kpi_convenios_activados: "Convenios activados",
    col_fecha: "Fecha",
    col_convenio: "Convenio",
    col_tipo: "Tipo",
    col_facultad: "Facultad",
    col_participantes: "Part.",
    col_direccion: "Dirección",
    empty: "Sin acciones registradas",
  },
  // Bulk Excel
  bulk: {
    page_title: "Carga Excel",
    kicker: "Registro masivo",
    desc: "Sube un archivo Excel (.xlsx) con múltiples acciones del semestre. Se validará fila por fila antes de guardar.",
    template_kicker: "◆ Recomendado",
    template_title: "Descarga la plantilla lista para usar",
    template_desc: "Archivo .xlsx con menús desplegables para elegir convenio, tipo, semestre y facultad. Sin necesidad de escribir IDs.",
    template_btn: "Descargar plantilla",
    template_generating: "Generando...",
    dropzone: "Sube tu archivo Excel",
    dropzone_hint: ".xlsx — se validará automáticamente al cargar",
    change_file: "Cambiar archivo",
    validating: "Validando filas contra la base de datos...",
    valid_stat: "Listas",
    invalid_stat: "Con errores",
    total_stat: "Total",
    valid_rows: "filas válidas",
    invalid_rows: "filas rechazadas",
    total_rows: "filas en el archivo",
    errors_title: "Filas con errores",
    errors_hint: "Corrige estas filas en el Excel y sube de nuevo. Las filas válidas pueden procesarse igual.",
    valid_title: "Filas listas para importar",
    confirm_btn: "Importar {{n}} fila(s)",
    no_valid: "No hay filas válidas",
    processing: "Procesando...",
    done_kicker: "Importación completa",
    done_title: "{{n}} acciones",
    done_title_em: "guardadas",
    inserted: "Insertadas",
    rejected: "Rechazadas",
    see_actions: "Ver acciones",
    new_upload: "Nueva carga",
    col_row: "Fila",
    col_error: "Error",
    col_data: "Datos",
    col_institucion: "Institución",
    col_tipo: "Tipo",
    col_facultad: "Facultad",
    col_period: "Periodo",
    col_part: "Part.",
  },
  // Estructuras
  estructuras: {
    page_title: "Estructuras",
    kicker: "Administración",
    desc: "Vicerrectorías, centros, institutos y otras unidades que ejecutan vinculación en paralelo a las facultades.",
    btn_new: "Nueva estructura",
    col_nombre: "Nombre",
    col_tipo: "Tipo",
    col_desc: "Descripción",
    empty: "Sin estructuras. Crea la primera para asociar convenios a vicerrectorías u otras unidades.",
    form_create: "Crear",
    form_edit: "Editar",
    form_new_title: "Nueva estructura",
    field_nombre: "Nombre",
    field_tipo: "Tipo",
    field_desc: "Descripción (opcional)",
    tipo: {
      vicerrectoria: "Vicerrectoría",
      centro: "Centro",
      instituto: "Instituto",
      direccion: "Dirección",
      otro: "Otro",
    },
  },
  // Facultades / Unidades / Usuarios / Configuracion
  admin: {
    facultades_title: "Facultades",
    btn_new_facultad: "Nueva facultad",
    unidades_desc: "Sub-nivel bajo {{plural}}. Útil para {{unidad_plural}}.",
    usuarios_title: "Usuarios",
    btn_new_user: "Nuevo usuario",
    kpi_admins: "Admins",
    kpi_facultades: "Facultades",
    config_title: "Configuración",
    config_desc: "Personaliza vincularedu según la estructura y terminología de tu institución.",
  },
  // Toasts comunes
  toast: {
    saved: "Guardado",
    error_generic: "Error",
    error_save: "Error al guardar",
    error_delete: "Error al eliminar",
    error_load: "Error al cargar",
    password_required: "Contraseña requerida",
    no_self_delete: "No puedes eliminar tu propia cuenta",
  },
  // Bulk extra (toasts y labels faltantes)
  bulk_x: {
    title_a: "Carga",
    title_em: "Excel",
    downloaded: "Plantilla descargada",
    download_err: "Error al descargar plantilla",
    ready: "{{n}} filas listas para procesar",
    invalid: "{{n}} fila(s) con error. Revisa antes de procesar.",
    validate_err: "Error al validar el Excel",
    process_err: "Error al procesar Excel",
    done: "{{n}} acciones importadas",
    total_filas: "Total filas",
  },
  // Dashboard extra
  dash_x: {
    loading: "Cargando dashboard...",
    title_facultad: "Mi facultad.",
    title_directivo: "Vista ejecutiva.",
    title_general: "Estado general.",
    desc: "Lo que realmente está pasando con tus convenios — actividad real, no solo papel firmado.",
    kpi_total: "Convenios totales",
    kpi_activos: "Activos",
    kpi_por_vencer: "Por vencer",
    kpi_vencidos: "Vencidos",
    star: "◆ Métrica estrella",
    mapa_kicker: "02 Distribución",
    mapa_h: "Mapa territorial",
    mapa_summary: "{{paises}} países · {{total}} convenios",
    ranking_kicker: "03 Ranking",
    facultad: "Facultad",
    convenios: "Convenios",
    acciones_12m: "Acciones 12m",
    no_data: "Sin datos",
    zombies_kicker: "Sin actividad",
    zombies_h: "Convenios",
    zombies_em: "zombies",
    zombies_ia: "IA detectó",
    zombies_ia_text: "{{n}} convenios activos sin ninguna acción en los últimos 12 meses.",
    zombies_empty: "No hay convenios zombies 🎉",
    alertas_kicker: "04 Alertas",
    alertas_h: "Próximos a",
    alertas_em: "vencer",
    col_institucion: "Institución",
    col_pais: "País",
    col_facultad: "Facultad",
    col_vence: "Vence en",
    days: "días",
    no_alerts: "Sin alertas",
    ver: "Ver",
  },
  // Convenio detail extra
  cd_x: {
    back: "Volver",
    not_found: "No encontrado",
    loading: "Cargando...",
    load_err: "No se pudo cargar el convenio",
    toast_action: "Acción registrada",
    confirm_delete: "¿Eliminar este convenio y todas sus acciones?",
    toast_deleted: "Convenio eliminado",
    confirm_cancel_nr: "¿Cancelar el proceso de no renovación?",
    toast_cancel_nr: "Proceso cancelado. Convenio vuelve a auto-renovable activo.",
    firma: "Firma",
    fecha_1er: "Fecha de 1er ciclo",
    vencimiento: "Vencimiento",
    auto_text: "Se renueva automáticamente. Aviso previo:",
    nr_kicker: "Proceso de no renovación",
    nr_given: "Aviso dado el",
    nr_ends: "Termina definitivamente el",
    nr_cancel: "Cancelar proceso",
    nr_start: "Iniciar proceso de no renovación",
    other_struct: "Otras estructuras",
    areas_tema: "Áreas temáticas",
    delete_btn: "Eliminar convenio",
    historial: "Historial",
    acciones_em: "acciones",
    empty: "Aún no hay acciones registradas",
    register_first: "Registrar la primera",
    semestre: "Semestre",
    nr_critical: "Acción crítica",
    nr_modal_title: "Iniciar no renovación",
    nr_modal_desc: "Con este paso notificas que el convenio no se renovará. El aviso previo estipulado es de",
    nr_modal_date: "Fecha efectiva de término",
    nr_modal_date_hint: "Día en que el convenio queda formalmente terminado.",
    nr_modal_reason: "Motivo (opcional)",
    nr_modal_confirm: "Confirmar no renovación",
    nr_modal_processing: "Procesando...",
    nr_modal_started: "Proceso de no renovación iniciado",
  },
  // Convenio new
  cn: {
    kicker: "Oficina de Vinculación",
    h1_a: "Cargar",
    h1_em: "convenio",
    desc: "Sube el PDF del convenio y la IA extraerá los datos automáticamente. Revisa, completa y confirma.",
    step1: "01 Archivo PDF",
    step2: "02 Datos del convenio",
    pdf_drop: "Sube el PDF del convenio",
    pdf_hint: "Formato PDF, máx 15MB. La IA extraerá instituciones, fechas y tipo.",
    processing: "Procesando con IA...",
    processing_sub: "GPT-5.2 está analizando el convenio",
    ai_done: "IA completó la extracción",
    ai_conf: "Confianza",
    change_file: "Cambiar archivo",
    scanned_hint: "¿PDF escaneado o ilegible? Completa el formulario manualmente a la derecha.",
    institucion: "Institución contraparte",
    pais: "País",
    ciudad: "Ciudad",
    tipo: "Tipo",
    tipo_inst: "Tipo Institución",
    inst_universidad: "Universidad",
    inst_empresa: "Empresa",
    inst_gobierno: "Gobierno",
    inst_ong: "ONG",
    inst_otro: "Otro",
    tipo_marco: "Marco",
    tipo_esp: "Específico",
    vigencia_label: "Vigencia",
    vig_fija: "Fecha fija",
    vig_fija_d: "Vence en fecha específica",
    vig_indef: "Indefinido",
    vig_indef_d: "Sin fecha de término",
    vig_auto: "Auto-renovable",
    vig_auto_d: "Se renueva salvo aviso",
    fecha_firma: "Fecha firma",
    fecha_vencimiento: "Fecha vencimiento",
    fecha_1er: "Fecha 1er ciclo",
    aviso: "Aviso previo para no renovar (días)",
    aviso_hint: "Días de antelación para avisar a la contraparte si no se quiere renovar. Habitualmente 30 días.",
    facultades_assoc: "{{plural}} asociadas",
    unidades_assoc: "{{plural}} asociadas (opcional)",
    estructuras_assoc: "Otras estructuras asociadas (vicerrectorías, centros, institutos) — opcional",
    areas: "Áreas temáticas (separadas por coma)",
    areas_ph: "ej: Ingeniería, Movilidad",
    observaciones: "Observaciones",
    submit_create: "Crear convenio",
    submit_saving: "Guardando...",
    must_pdf: "Debe ser un archivo PDF",
    ai_extract_done: "Datos extraídos por IA",
    ai_extract_err: "Error extrayendo PDF. Completa el formulario manualmente.",
    created: "Convenio creado",
  },
  // Facultades page
  fac: {
    page_title: "Facultades",
    btn_new: "Nueva facultad",
    no_data: "No hay facultades registradas",
    users: "usuarios",
    convenios: "convenios",
    modal_new: "Nueva",
    modal_edit: "Editar",
    create_title: "Crear facultad",
    update_title: "Actualizar facultad",
    field_nombre: "Nombre",
    field_codigo: "Código",
    field_codigo_ph: "FING, FCS, FMED...",
    field_contacto: "Contacto coordinador",
    field_contacto_ph: "coord@uni.edu",
    saving: "Guardando...",
    create: "Crear",
    update: "Actualizar",
    toast_created: "Facultad creada",
    toast_updated: "Facultad actualizada",
    toast_deleted: "Facultad eliminada",
    confirm_delete: "¿Eliminar {{name}}?",
    cannot_delete: "No se puede eliminar: {{users}} usuario(s) y {{convs}} convenio(s) asociados",
  },
  // Unidades page
  uni: {
    desc: "Sub-nivel bajo {{plural}}. Útil para {{unidad_plural}}.",
    default_plural: "facultades",
    default_unidad_plural: "escuelas, departamentos o carreras",
    btn_new: "Nueva {{singular}}",
    no_data: "No hay {{plural}} registradas",
    users: "usuarios",
    convenios: "convenios",
    modal_new: "Nueva",
    modal_edit: "Editar",
    create_title: "Crear {{singular}}",
    update_title: "Actualizar {{singular}}",
    field_nombre: "Nombre",
    field_codigo: "Código",
    field_facultad: "{{facultad}} (opcional)",
    field_facultad_none: "— Sin {{facultad}} —",
    field_contacto: "Contacto coordinador",
    facultad_prefix: "{{facultad}}:",
    saving: "Guardando...",
    create: "Crear",
    update: "Actualizar",
    toast_created: "Unidad creada",
    toast_updated: "Unidad actualizada",
    toast_deleted: "Unidad eliminada",
    confirm_delete: "¿Eliminar {{name}}?",
    cannot_delete: "No se puede eliminar: {{users}} usuario(s) y {{convs}} convenio(s) asociados",
  },
  // Usuarios page
  usr: {
    page_title: "Usuarios",
    btn_new: "Nuevo usuario",
    kpi_total: "Total",
    kpi_admins: "Admins",
    kpi_facultades: "Facultades",
    col_nombre: "Nombre",
    col_email: "Email",
    col_rol: "Rol",
    col_facultad: "Facultad",
    you: "(tú)",
    modal_new: "Nuevo",
    modal_edit: "Editar",
    create_title: "Crear usuario",
    update_title: "Actualizar usuario",
    field_nombre: "Nombre",
    field_email: "Email",
    field_password: "Contraseña",
    field_password_hint: "(vacío = no cambiar)",
    field_rol: "Rol",
    rol_admin: "Oficina de Vinculación",
    rol_directivo: "Directivo",
    field_unidad: "Unidad",
    select_default: "Selecciona...",
    saving: "Guardando...",
    create: "Crear",
    update: "Actualizar",
    toast_created: "Usuario creado",
    toast_updated: "Usuario actualizado",
    toast_deleted: "Usuario eliminado",
    confirm_delete: "¿Eliminar a {{name}}?",
  },
  // Configuración page
  cfg: {
    page_title: "Configuración",
    desc: "Personaliza vincularedu según la estructura y terminología de tu institución.",
    inst_h: "Institución",
    inst_sub: "Datos básicos de tu universidad.",
    inst_nombre: "Nombre de la institución",
    jer_h_a: "Jerarquía",
    jer_h_em: "organizacional",
    jer_sub: "Renombra los niveles según tu institución. Ejemplos: \"División\" en vez de Facultad, o \"Carrera\" en vez de Unidad Académica. Si tu universidad no tiene Facultades, desactiva el segundo nivel.",
    nivel1: "Nivel 1",
    nivel2: "Nivel 2 (opcional)",
    singular: "Nombre singular",
    plural: "Nombre plural",
    activado: "Activado",
    desactivado: "Desactivado",
    alerta_h_a: "Umbral de",
    alerta_h_em: "alerta",
    alerta_sub: "Cuántos días antes del vencimiento un convenio pasa al estado \"por vencer\". Por defecto: 90 días.",
    dias: "Días",
    months: "meses",
    saving: "Guardando...",
    save: "Guardar configuración",
    toast_saved: "Configuración actualizada",
  },
  // Estructuras extra
  est_x: {
    loading: "Cargando...",
    toast_created: "Estructura creada",
    toast_updated: "Estructura actualizada",
    toast_deleted: "Eliminada",
    confirm_delete: "¿Eliminar \"{{name}}\"?",
    cancel: "Cancelar",
    save: "Guardar",
    create: "Crear",
  },
  // Modal Nueva Acción
  af: {
    kicker: "Registrar",
    title: "Nueva acción",
    under: "Bajo convenio con",
    convenio_label: "Convenio",
    select_default: "Selecciona...",
    tipo_label: "Tipo de acción",
    otro_desc_label: "Descripción (requerida)",
    semestre: "Semestre",
    anio: "Año",
    sem_1: "1°",
    sem_2: "2°",
    sem_verano: "Verano",
    participantes: "Participantes",
    direccion: "Dirección",
    dir_na: "—",
    dir_entrante: "Entrante",
    dir_saliente: "Saliente",
    facultad: "Facultad ejecutante",
    obs: "Observaciones (opcional)",
    cancel: "Cancelar",
    saving: "Guardando...",
    submit: "Guardar acción",
    err_convenio: "Selecciona un convenio",
    err_facultad: "Selecciona una facultad",
    err_otro: "Describe el tipo 'Otro'",
    // Tipos de acción
    tipo_intercambio: "Intercambio estudiantil",
    tipo_pasantia: "Pasantía docente",
    tipo_proyecto: "Proyecto de investigación conjunto",
    tipo_publicacion: "Publicación conjunta",
    tipo_cotutela: "Cotutela de tesis",
    tipo_evento: "Evento o seminario conjunto",
    tipo_visita: "Visita institucional",
    tipo_otro: "Otro",
  },
};

const en = {
  brand: { tagline: "University intelligence" },
  nav: {
    dashboard: "Dashboard",
    convenios: "Agreements",
    convenios_mis: "My agreements",
    cargar_convenio: "Upload agreement",
    acciones: "Activities",
    registrar_accion: "Log activity",
    facultades: "Faculties",
    unidades: "Units",
    estructuras: "Other structures",
    usuarios: "Users",
    configuracion: "Settings",
    mi_facultad: "My faculty",
    mi_unidad: "My unit",
    cerrar_sesion: "Log out",
    volver_inicio: "Back to home",
    ingresar: "Sign in",
    probar_demo: "Try demo",
    acceso_clientes: "Client access",
  },
  landing: {
    intel_tagline: "Intelligence for university partnerships",
    hero_q1: "Know what's happening",
    hero_q2: "with your agreements.",
    hero_desc:
      "vincularedu shows you what's really going on with each institutional agreement: validity, activities, impact. Make better decisions and keep",
    hero_desc_em: "timely, consistent information",
    hero_desc_after:
      "ready for accreditation at the academic unit and program level.",
    cta_demo: "Try the demo",
    cta_login: "Client access",
    demo_disclaimer: "No signup needed · Sample data · Auto-resets",
    discover: "What universities discover",
    convenios_firmados: "Agreements signed",
    activos_verdad: "Truly active",
    por_vencer_90d: "Expiring (90d)",
    sin_actividad: "No activity",
    quote:
      "“Half had no movement in years” — typical story from an international affairs director.",
    section_producto: "Product",
    section_producto_kicker: "01 Product",
    section_producto_h: "Everything you need to manage",
    section_producto_em: "real partnerships",
    feat_ocr_t: "AI-powered OCR",
    feat_ocr_d: "Upload the agreement PDF. GPT-5.2 extracts institution, dates, topics and type. You only review and confirm.",
    feat_acc_t: "Activities per agreement",
    feat_acc_d: "Log exchanges, internships, publications and events. One by one or via smart Excel bulk upload.",
    feat_dash_t: "Executive dashboard",
    feat_dash_d: "Validity traffic light, activation rate, world map, zombie agreements and expiry alerts.",
    feat_vig_t: "Flexible validity",
    feat_vig_d: "Fixed date, indefinite or auto-renewable. Trigger non-renewal with configurable notice period.",
    feat_roles_t: "Clear roles",
    feat_roles_d: "Partnerships Office, Faculties, Units and Executives. Each sees and edits what they should.",
    feat_conf_t: "Accreditation-ready",
    feat_conf_d: "Traceability by academic unit and program. Consistent reports and auditable data for accreditation.",
    section_flujo: "How it works",
    section_flujo_kicker: "02 How it works",
    section_flujo_h: "From a forgotten PDF to",
    section_flujo_em: "actionable data",
    flujo_1_t: "Upload the agreement",
    flujo_1_d: "Signed PDF, template or manual entry. AI does the heavy lifting.",
    flujo_2_t: "Assign structure",
    flujo_2_d: "Link the agreement to the responsible faculties, units or vice-rectorates.",
    flujo_3_t: "Log activities",
    flujo_3_d: "Every exchange, event or publication under that agreement is tracked.",
    flujo_4_t: "See the impact",
    flujo_4_d: "Activation rate, unit ranking, countries covered. Reality, not paperwork.",
    section_for: "Who it's for",
    section_for_kicker: "03 Who it's for",
    section_for_h: "Built for",
    section_for_em: "universities",
    section_for_h2: "that want to make better decisions.",
    section_for_desc:
      "If your institution has more than 50 agreements and doesn't know how many are alive, vincularedu is for you. Implemented in days, not months.",
    p1_rol: "Partnerships / International Affairs Offices",
    p1_v: "Single catalog, AI to extract data from PDFs and a global dashboard.",
    p2_rol: "Deans and faculties",
    p2_v: "Log the semester's activities and see your own performance.",
    p3_rol: "Vice-rectorates & accreditation",
    p3_v: "Consistent, traceable data for accreditation processes and executive reports.",
    final_cta_kicker: "Start now",
    final_cta_h1: "Want",
    final_cta_em: "better decisions",
    final_cta_h2: "and consistent data",
    final_cta_h3: "for accreditation?",
    final_cta_desc:
      "Try the demo without signing up or request access for your university. No install, no commitment.",
    footer_tag: "University intelligence",
  },
  login: {
    kicker: "Client access",
    title: "Sign in.",
    no_account: "For universities with an active account. No account?",
    try_demo: "Try the demo",
    email: "Email",
    password: "Password",
    submit: "Sign in",
    loading: "Signing in...",
    contact_text: "Your university doesn't have an account yet?",
  },
  demo: {
    kicker: "Demo mode · Shared data",
    h1_a: "Sign in as",
    h1_em: "anyone",
    desc:
      "Explore vincularedu with sample data. Each profile shows a different experience. No signup — data is shared between visitors and resets periodically.",
    enter_as: "Sign in as",
    enter: "Enter",
    entering: "Entering...",
    warn_title: "Important",
    warn_text:
      "This is a demo environment with shared data between all visitors. Anything you create, modify or delete will be visible to others. For a private environment for your university,",
    warn_link: "use client access",
    warn_or: "or",
    warn_contact: "contact us",
    roles: {
      admin_label: "Partnerships Office (Admin)",
      admin_desc: "Create agreements, manage faculties, see global dashboard.",
      facultad_label: "Faculty of Engineering",
      facultad_desc: "Log activities under their agreements.",
      unidad_label: "Academic Unit (Informatics)",
      unidad_desc: "Sub-level below faculty.",
      directivo_label: "Executive (Rector)",
      directivo_desc: "Read-only executive view.",
    },
  },
  dashboard: {
    kicker: "Dashboard",
    metrica_estrella: "Star metric",
    tasa_a: "Activation",
    tasa_em: "rate",
    tasa_desc: "Active agreements with at least one activity in the last 12 months.",
    de: "of",
    activos_label: "active",
    actividad: "Activity",
    acciones_12m: "activities last 12 months",
    cobertura: "Coverage",
    paises_distintos: "distinct countries",
    distribucion: "Distribution",
    mapa_territorial: "Territorial map",
    ranking: "Ranking",
    facultades_por: "Faculties by",
    actividad_em: "activity",
    sin_actividad: "No activity",
    convenios_zombies: "zombies",
    alertas: "Alerts",
    proximos: "Expiring",
    vencer: "soon",
    title_suffix: "University intelligence",
  },
  common: {
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    new: "New",
    search: "Search",
    filters: "Filters",
    total: "Total",
    pais: "Country",
    tipo: "Type",
    estado: "Status",
    vigencia: "Validity",
    todos: "All",
    activos: "Active",
    por_vencer: "Expiring",
    vencidos: "Expired",
    language: "Language",
    welcome: "Welcome",
    session_started: "Signed in",
    back: "Back",
    yes: "Yes",
    no: "No",
    optional: "optional",
    administration: "Administration",
  },
  convenios: {
    page_title: "Agreements",
    kicker: "Institutional registry",
    kicker_mis: "My agreements",
    btn_new: "Upload agreement",
    search_placeholder: "Search by institution, country, city, topics, notes…",
    searching_tokens: "Searching {{n}} terms:",
    col_institucion: "Institution",
    col_pais: "Country",
    col_tipo: "Type",
    col_facultad: "Faculty",
    col_vencimiento: "Expires",
    col_estado: "Status",
    empty: "No agreements",
    no_match: "No agreements match the filters",
    of_label: "of",
    results_one: "agreement",
    results_other: "agreements",
    clear_all: "Clear all",
    clear_filters: "Clear filters",
    filters_active: "{{n}} active filter(s)",
    indefinido: "Indefinite",
    vig_fija: "Fixed date",
    vig_auto: "Auto-renewable",
    tipo_marco: "Framework",
    tipo_esp: "Specific",
  },
  convenio_detail: {
    btn_register_action: "Log activity",
    section_vigencia: "Validity",
    section_partes: "Parties",
    section_actividad: "Activity",
    fecha_firma: "Signed on",
    fecha_vencimiento: "Expires",
    aviso_previo: "Notice period",
    days: "days",
    no_renovacion: "Non-renewal triggered",
    motivo: "Reason",
    btn_iniciar_no_renov: "Trigger non-renewal",
    btn_cancelar_no_renov: "Cancel non-renewal",
    historial: "Activity history",
    sin_acciones: "No activities logged",
    participantes: "participants",
  },
  acciones: {
    page_title: "Activities",
    kicker: "Log",
    btn_new: "New activity",
    btn_bulk: "Excel upload",
    kpi_total: "Total",
    kpi_participantes: "Participants",
    kpi_convenios_activados: "Activated agreements",
    col_fecha: "Date",
    col_convenio: "Agreement",
    col_tipo: "Type",
    col_facultad: "Faculty",
    col_participantes: "People",
    col_direccion: "Direction",
    empty: "No activities logged",
  },
  bulk: {
    page_title: "Excel upload",
    kicker: "Bulk log",
    desc: "Upload an Excel file (.xlsx) with multiple activities. Each row is validated before saving.",
    template_kicker: "◆ Recommended",
    template_title: "Download the ready-to-use template",
    template_desc: ".xlsx file with dropdowns to pick agreement, type, semester and faculty. No need to type IDs.",
    template_btn: "Download template",
    template_generating: "Generating...",
    dropzone: "Upload your Excel file",
    dropzone_hint: ".xlsx — auto-validated on upload",
    change_file: "Change file",
    validating: "Validating rows against the database...",
    valid_stat: "Ready",
    invalid_stat: "With errors",
    total_stat: "Total",
    valid_rows: "valid rows",
    invalid_rows: "rejected rows",
    total_rows: "rows in file",
    errors_title: "Rows with errors",
    errors_hint: "Fix these rows in Excel and re-upload. Valid rows can still be processed.",
    valid_title: "Rows ready to import",
    confirm_btn: "Import {{n}} row(s)",
    no_valid: "No valid rows",
    processing: "Processing...",
    done_kicker: "Import complete",
    done_title: "{{n}} activities",
    done_title_em: "saved",
    inserted: "Inserted",
    rejected: "Rejected",
    see_actions: "See activities",
    new_upload: "New upload",
    col_row: "Row",
    col_error: "Error",
    col_data: "Data",
    col_institucion: "Institution",
    col_tipo: "Type",
    col_facultad: "Faculty",
    col_period: "Period",
    col_part: "People",
  },
  estructuras: {
    page_title: "Other structures",
    kicker: "Administration",
    desc: "Vice-rectorates, centers, institutes and other units that run partnerships alongside faculties.",
    btn_new: "New structure",
    col_nombre: "Name",
    col_tipo: "Type",
    col_desc: "Description",
    empty: "No structures yet. Create the first one to link agreements to vice-rectorates or other units.",
    form_create: "Create",
    form_edit: "Edit",
    form_new_title: "New structure",
    field_nombre: "Name",
    field_tipo: "Type",
    field_desc: "Description (optional)",
    tipo: {
      vicerrectoria: "Vice-rectorate",
      centro: "Center",
      instituto: "Institute",
      direccion: "Office",
      otro: "Other",
    },
  },
  admin: {
    facultades_title: "Faculties",
    btn_new_facultad: "New faculty",
    unidades_desc: "Sub-level under {{plural}}. Useful for {{unidad_plural}}.",
    usuarios_title: "Users",
    btn_new_user: "New user",
    kpi_admins: "Admins",
    kpi_facultades: "Faculties",
    config_title: "Settings",
    config_desc: "Customize vincularedu to your institution's structure and terminology.",
  },
  toast: {
    saved: "Saved",
    error_generic: "Error",
    error_save: "Save error",
    error_delete: "Delete error",
    error_load: "Load error",
    password_required: "Password required",
    no_self_delete: "You can't delete your own account",
  },
  bulk_x: {
    title_a: "Excel",
    title_em: "upload",
    downloaded: "Template downloaded",
    download_err: "Error downloading template",
    ready: "{{n}} rows ready to process",
    invalid: "{{n}} row(s) with errors. Review before processing.",
    validate_err: "Error validating Excel",
    process_err: "Error processing Excel",
    done: "{{n}} activities imported",
    total_filas: "Total rows",
  },
  dash_x: {
    loading: "Loading dashboard...",
    title_facultad: "My faculty.",
    title_directivo: "Executive view.",
    title_general: "Overall status.",
    desc: "What's really happening with your agreements — real activity, not just signed paper.",
    kpi_total: "Total agreements",
    kpi_activos: "Active",
    kpi_por_vencer: "Expiring",
    kpi_vencidos: "Expired",
    star: "◆ Star metric",
    mapa_kicker: "02 Distribution",
    mapa_h: "Territorial map",
    mapa_summary: "{{paises}} countries · {{total}} agreements",
    ranking_kicker: "03 Ranking",
    facultad: "Faculty",
    convenios: "Agreements",
    acciones_12m: "Activities 12m",
    no_data: "No data",
    zombies_kicker: "No activity",
    zombies_h: "Zombie",
    zombies_em: "agreements",
    zombies_ia: "AI detected",
    zombies_ia_text: "{{n}} active agreements without any activity in the last 12 months.",
    zombies_empty: "No zombie agreements 🎉",
    alertas_kicker: "04 Alerts",
    alertas_h: "Expiring",
    alertas_em: "soon",
    col_institucion: "Institution",
    col_pais: "Country",
    col_facultad: "Faculty",
    col_vence: "Expires in",
    days: "days",
    no_alerts: "No alerts",
    ver: "View",
  },
  cd_x: {
    back: "Back",
    not_found: "Not found",
    loading: "Loading...",
    load_err: "Could not load agreement",
    toast_action: "Activity logged",
    confirm_delete: "Delete this agreement and all its activities?",
    toast_deleted: "Agreement deleted",
    confirm_cancel_nr: "Cancel the non-renewal process?",
    toast_cancel_nr: "Process cancelled. Agreement is auto-renewable again.",
    firma: "Signed",
    fecha_1er: "First cycle end",
    vencimiento: "Expires",
    auto_text: "Auto-renews. Notice period:",
    nr_kicker: "Non-renewal process",
    nr_given: "Notice given on",
    nr_ends: "Definitively ends on",
    nr_cancel: "Cancel process",
    nr_start: "Trigger non-renewal process",
    other_struct: "Other structures",
    areas_tema: "Topics",
    delete_btn: "Delete agreement",
    historial: "History",
    acciones_em: "activities",
    empty: "No activities logged yet",
    register_first: "Log the first",
    semestre: "Semester",
    nr_critical: "Critical action",
    nr_modal_title: "Trigger non-renewal",
    nr_modal_desc: "This notifies that the agreement won't be renewed. The notice period is",
    nr_modal_date: "Effective end date",
    nr_modal_date_hint: "Day on which the agreement formally ends.",
    nr_modal_reason: "Reason (optional)",
    nr_modal_confirm: "Confirm non-renewal",
    nr_modal_processing: "Processing...",
    nr_modal_started: "Non-renewal process started",
  },
  cn: {
    kicker: "Partnerships Office",
    h1_a: "Upload",
    h1_em: "agreement",
    desc: "Upload the agreement PDF and AI will extract data automatically. Review, complete and confirm.",
    step1: "01 PDF file",
    step2: "02 Agreement data",
    pdf_drop: "Upload the agreement PDF",
    pdf_hint: "PDF format, 15MB max. AI will extract institutions, dates and type.",
    processing: "Processing with AI...",
    processing_sub: "GPT-5.2 is analyzing the agreement",
    ai_done: "AI completed extraction",
    ai_conf: "Confidence",
    change_file: "Change file",
    scanned_hint: "Scanned or unreadable PDF? Fill the form manually on the right.",
    institucion: "Counterparty institution",
    pais: "Country",
    ciudad: "City",
    tipo: "Type",
    tipo_inst: "Institution type",
    inst_universidad: "University",
    inst_empresa: "Company",
    inst_gobierno: "Government",
    inst_ong: "NGO",
    inst_otro: "Other",
    tipo_marco: "Framework",
    tipo_esp: "Specific",
    vigencia_label: "Validity",
    vig_fija: "Fixed date",
    vig_fija_d: "Expires on a specific date",
    vig_indef: "Indefinite",
    vig_indef_d: "No end date",
    vig_auto: "Auto-renewable",
    vig_auto_d: "Renews unless notified",
    fecha_firma: "Signed on",
    fecha_vencimiento: "End date",
    fecha_1er: "First cycle end",
    aviso: "Notice period for non-renewal (days)",
    aviso_hint: "Days of advance notice to inform counterparty if you don't want to renew. Usually 30 days.",
    facultades_assoc: "Associated {{plural}}",
    unidades_assoc: "Associated {{plural}} (optional)",
    estructuras_assoc: "Other associated structures (vice-rectorates, centers, institutes) — optional",
    areas: "Topics (comma-separated)",
    areas_ph: "e.g.: Engineering, Mobility",
    observaciones: "Notes",
    submit_create: "Create agreement",
    submit_saving: "Saving...",
    must_pdf: "Must be a PDF file",
    ai_extract_done: "Data extracted by AI",
    ai_extract_err: "Error extracting PDF. Fill the form manually.",
    created: "Agreement created",
  },
  fac: {
    page_title: "Faculties",
    btn_new: "New faculty",
    no_data: "No faculties registered",
    users: "users",
    convenios: "agreements",
    modal_new: "New",
    modal_edit: "Edit",
    create_title: "Create faculty",
    update_title: "Update faculty",
    field_nombre: "Name",
    field_codigo: "Code",
    field_codigo_ph: "FING, FCS, FMED...",
    field_contacto: "Coordinator contact",
    field_contacto_ph: "coord@uni.edu",
    saving: "Saving...",
    create: "Create",
    update: "Update",
    toast_created: "Faculty created",
    toast_updated: "Faculty updated",
    toast_deleted: "Faculty deleted",
    confirm_delete: "Delete {{name}}?",
    cannot_delete: "Cannot delete: {{users}} user(s) and {{convs}} agreement(s) linked",
  },
  uni: {
    desc: "Sub-level under {{plural}}. Useful for {{unidad_plural}}.",
    default_plural: "faculties",
    default_unidad_plural: "schools, departments or programs",
    btn_new: "New {{singular}}",
    no_data: "No {{plural}} registered",
    users: "users",
    convenios: "agreements",
    modal_new: "New",
    modal_edit: "Edit",
    create_title: "Create {{singular}}",
    update_title: "Update {{singular}}",
    field_nombre: "Name",
    field_codigo: "Code",
    field_facultad: "{{facultad}} (optional)",
    field_facultad_none: "— No {{facultad}} —",
    field_contacto: "Coordinator contact",
    facultad_prefix: "{{facultad}}:",
    saving: "Saving...",
    create: "Create",
    update: "Update",
    toast_created: "Unit created",
    toast_updated: "Unit updated",
    toast_deleted: "Unit deleted",
    confirm_delete: "Delete {{name}}?",
    cannot_delete: "Cannot delete: {{users}} user(s) and {{convs}} agreement(s) linked",
  },
  usr: {
    page_title: "Users",
    btn_new: "New user",
    kpi_total: "Total",
    kpi_admins: "Admins",
    kpi_facultades: "Faculties",
    col_nombre: "Name",
    col_email: "Email",
    col_rol: "Role",
    col_facultad: "Faculty",
    you: "(you)",
    modal_new: "New",
    modal_edit: "Edit",
    create_title: "Create user",
    update_title: "Update user",
    field_nombre: "Name",
    field_email: "Email",
    field_password: "Password",
    field_password_hint: "(empty = don't change)",
    field_rol: "Role",
    rol_admin: "Partnerships Office",
    rol_directivo: "Executive",
    field_unidad: "Unit",
    select_default: "Select...",
    saving: "Saving...",
    create: "Create",
    update: "Update",
    toast_created: "User created",
    toast_updated: "User updated",
    toast_deleted: "User deleted",
    confirm_delete: "Delete {{name}}?",
  },
  cfg: {
    page_title: "Settings",
    desc: "Customize vincularedu to your institution's structure and terminology.",
    inst_h: "Institution",
    inst_sub: "Basic data of your university.",
    inst_nombre: "Institution name",
    jer_h_a: "Organizational",
    jer_h_em: "hierarchy",
    jer_sub: "Rename the levels to match your institution. Examples: \"Division\" instead of Faculty, or \"Program\" instead of Academic Unit. If your university doesn't have Faculties, disable the second level.",
    nivel1: "Level 1",
    nivel2: "Level 2 (optional)",
    singular: "Singular name",
    plural: "Plural name",
    activado: "Enabled",
    desactivado: "Disabled",
    alerta_h_a: "Alert",
    alerta_h_em: "threshold",
    alerta_sub: "How many days before expiry an agreement moves to \"expiring\" status. Default: 90 days.",
    dias: "Days",
    months: "months",
    saving: "Saving...",
    save: "Save settings",
    toast_saved: "Settings updated",
  },
  est_x: {
    loading: "Loading...",
    toast_created: "Structure created",
    toast_updated: "Structure updated",
    toast_deleted: "Deleted",
    confirm_delete: "Delete \"{{name}}\"?",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
  },
  af: {
    kicker: "Log",
    title: "New activity",
    under: "Under agreement with",
    convenio_label: "Agreement",
    select_default: "Select...",
    tipo_label: "Activity type",
    otro_desc_label: "Description (required)",
    semestre: "Semester",
    anio: "Year",
    sem_1: "1st",
    sem_2: "2nd",
    sem_verano: "Summer",
    participantes: "Participants",
    direccion: "Direction",
    dir_na: "—",
    dir_entrante: "Inbound",
    dir_saliente: "Outbound",
    facultad: "Executing faculty",
    obs: "Notes (optional)",
    cancel: "Cancel",
    saving: "Saving...",
    submit: "Save activity",
    err_convenio: "Select an agreement",
    err_facultad: "Select a faculty",
    err_otro: "Describe the 'Other' type",
    tipo_intercambio: "Student exchange",
    tipo_pasantia: "Faculty internship",
    tipo_proyecto: "Joint research project",
    tipo_publicacion: "Joint publication",
    tipo_cotutela: "Thesis co-supervision",
    tipo_evento: "Joint event or seminar",
    tipo_visita: "Institutional visit",
    tipo_otro: "Other",
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "vinculo_lang" },
    interpolation: { escapeValue: false },
  });

export default i18n;
